<script>
	export let grid = null
	export let cls = null
	export let shiftBy = '1'
	export let colspan = 'col-span-12 xl:col-span-10'
</script>

<div class="grid grid-cols-12 justify-center">
	<div class="col-span-{shiftBy} hidden xl:block" />
	<div class="relative mx-auto w-full {colspan} {grid} {cls}">
		<slot />
	</div>
</div>
